import React, { Component } from "react";
import InfiniteScroll from "react-infinite-scroller";
import { LoaderIcon } from "../../assets/icons/LoaderIcon";
import { RemoveIcon } from "../../assets/icons/RemoveIcon";
import { withRCEHelpers } from "../rce-helpers-context";
import styles from "./voted-users.rtlignore-scss";
import VoterAvatar from "./VoterAvatar";
class VotedUsersModalComponent extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      members: [],
      moreItems: true,
      cursor: void 0
    };
    this.fetchVoters = async () => {
      const { cursor } = this.state;
      try {
        const { voters, moreItems } = await this.props.fetchVoters({ cursor, limit: 10 });
        const members = await this.props.rce.getSiteMembers(voters.map((v) => v.memberId)) || [];
        this.setState({
          members: this.state.members.concat(members),
          cursor: voters[voters.length - 1].memberId,
          moreItems
        });
      } catch (error) {
      }
    };
  }
  render() {
    const { t, option, onRequestClose } = this.props;
    const { members, moreItems } = this.state;
    return /* @__PURE__ */ React.createElement("div", { className: styles.voted_users_modal }, /* @__PURE__ */ React.createElement("div", { className: styles.voted_users_modal_header }, /* @__PURE__ */ React.createElement("p", { className: styles.title }, t("Poll_Viewer_VoteCount_Modal_Voters_Header", {
      count: option.count,
      number: option.count
    })), /* @__PURE__ */ React.createElement(RemoveIcon, { onClick: onRequestClose, className: styles.close_icon })), /* @__PURE__ */ React.createElement(
      InfiniteScroll,
      {
        className: styles.member_list_container,
        initialLoad: true,
        hasMore: moreItems,
        loadMore: this.fetchVoters,
        loader: /* @__PURE__ */ React.createElement("div", { className: styles.loader }, /* @__PURE__ */ React.createElement(LoaderIcon, { width: 24, height: 24, className: styles.spinner }))
      },
      /* @__PURE__ */ React.createElement("ul", { className: styles.member_list }, members.map((member) => {
        return member ? /* @__PURE__ */ React.createElement("li", { key: member.siteMemberId }, /* @__PURE__ */ React.createElement("div", { className: styles.user_card }, /* @__PURE__ */ React.createElement(
          VoterAvatar,
          {
            className: styles.user_avatar,
            member,
            src: member.imageUrl,
            size: {
              width: 36,
              height: 36
            }
          }
        ), /* @__PURE__ */ React.createElement("span", { className: styles.user_name }, member.name?.nick || t("Poll_Viewer_VoteCount_Modal_Voters_Private_Voter")))) : null;
      }))
    ), option.anonymousCount ? /* @__PURE__ */ React.createElement("p", { className: styles.anonymous_counter }, t("Poll_Viewer_VoteCount_Modal_Voters_Anonymous", {
      anonNumber: option.anonymousCount
    })) : null);
  }
}
const VotedUsersModal = withRCEHelpers(VotedUsersModalComponent);
export {
  VotedUsersModal
};
//# sourceMappingURL=VotedUsersModal.js.map
